module.exports = __webpack_public_path__ + "static/media/t61.07cf562f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/portfolio/t61.png
// module id = 332
// module chunks = 0